// Size rules for every policy upload, checked in the browser before the file is sent. The policy
// endpoints cap the whole request at 21 MiB, so a file just past 20 MB is cut off by the server
// before its own size check runs and the browser reports only "Network Error". Messages match the
// server's, so the user sees the same text either way.
export const MAX_POLICY_FILE_BYTES = 20 * 1024 * 1024;

export const policyFileError = (file) => {
    if (!file) return null;
    if (file.size === 0) return "The file is empty.";
    if (file.size > MAX_POLICY_FILE_BYTES) return "File exceeds 20 MB limit.";
    return null;
};
